import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ActiveCollaboratorsWidget = ({ collaborators }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <div>
          <h3 className="text-base md:text-lg font-semibold text-foreground mb-1">Active Now</h3>
          <p className="text-xs md:text-sm text-muted-foreground">{collaborators?.length} team members online</p>
        </div>
        <div className="p-2 rounded-lg bg-success/10 text-success">
          <Icon name="Users" size={20} />
        </div>
      </div>
      <div className="space-y-3 md:space-y-4">
        {collaborators?.map((collaborator, index) => (
          <div key={index} className="flex items-center gap-3 p-2 md:p-3 hover:bg-muted/50 rounded-lg transition-colors duration-200">
            <div className="relative flex-shrink-0">
              <Image
                src={collaborator?.avatar}
                alt={collaborator?.avatarAlt}
                className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover"
              />
              <div className="absolute bottom-0 right-0 w-3 h-3 bg-success border-2 border-card rounded-full"></div>
            </div>
            
            <div className="flex-1 min-w-0">
              <p className="text-xs md:text-sm font-medium text-foreground truncate">{collaborator?.name}</p>
              <div className="flex items-center gap-2 mt-1">
                <Icon name={collaborator?.activityIcon} size={12} className="text-muted-foreground flex-shrink-0" />
                <p className="text-xs text-muted-foreground truncate">{collaborator?.activity}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActiveCollaboratorsWidget;